import { createFileRoute } from "@tanstack/react-router";
import { TradeGuidePage, seoHead } from "@/components/hubs/HubPages";
import { TRADE_GUIDES } from "@/lib/regionalHubs";

const DATA = TRADE_GUIDES.find((x) => x.slug === "/learn/page-10-to-page-1-seo-colorado")!;

export const Route = createFileRoute("/learn/page-10-to-page-1-seo-colorado")({
  head: () => seoHead("/learn/page-10-to-page-1-seo-colorado", "From page 10 to page 1: how Colorado businesses climb Google", "The step-by-step process Chris Heidlebaugh has used for 27 years to move Colorado business websites from pages 6\u201310 of Google to page one.", "article"),
  component: () => <TradeGuidePage guide={DATA} />,
});
